import React, { useCallback, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import MangeDashboard from "./ManageDashboard";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import OfferList from "./OfferList";
import AfterLoginNav from "../AfterLoginNav";
import BottomSheet from "../BottomSheet";
import FilterModal from "../FilterModal";
import CategoryModal from "../CategoryModal";
import { getCurrentGoldPrice } from "../../services/gold-price";
import { getSystemContents } from "../../services/statistics";
import { submitOfferRequest, submitTradeRequest } from "../../services/trade";
import ScrollOnMainPage from "../ScrollOnMainPage";
import { getCommoditiesList } from "../../services/commodities";
let activeOrderTmp = null;
export default function LimitOrder() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const [activeTable, setActiveTable] = useState(2);
  const [activeOrder, setActiveOrder] = useState(null);
  const [active, setActive] = useState("buy");
  const [isLoading, setIsLoading] = useState(false);
  const [commodities, setCommodities] = useState([]);
  const [selectedCommodity, setSelectedCommodity] = useState({
    id: "",
    ui_data: { unit_name: "" },
  });
  const [commodityName, setCommodityName] = useState("");
  const [gramBuy, setGramBuy] = useState(0);
  const [soatBuy, setSoatBuy] = useState(0);
  const [gramSell, setGramSell] = useState(0);
  const [soatSell, setSoatSell] = useState(0);
  const [priceBuyOffer, setPriceBuyOffer] = useState();
  const [priceSellOffer, setPriceSellOffer] = useState();
  const [initAmount, setInitAmount] = useState(null);
  const [landing, setLanding] = useState([]);
  const [amountBuy, setAmountBuy] = useState(0);
  const [amountSell, setAmountSell] = useState(0);
  const [activate, setActivate] = useState(false);
  const [activateModal, setActivateModal] = useState(false);
  const [filterType, setFilterType] = useState(null);
  const [filterAmount, setFilterAmount] = useState(null);
  const [filterRange, setFilterRange] = useState(null);
  const fetchCommodities = useCallback(() => {
    getCommoditiesList().then((res) => {
      if (res.status === 200) {
        const data = res?.data?.results;
        if (data) {
          setCommodities(data);
          const commodity_id = params.get("commodity_id");
          let selectedId = data[0].id;
          if (commodity_id) {
            selectedId = commodity_id;
          }
          const comName = data.find((el) => el.id == selectedId)?.name;
          const selected = data.find((el) => el.id == selectedId);
          setCommodityName(comName);
          setSelectedCommodity(selected);
        }
      }
    });
  }, [location]);
  useEffect(() => {
    const typeItem = params.get("type");
    const orderItem = params.get("order");
    if (typeItem && orderItem) {
      setInitAmount({ type: typeItem, order: orderItem });
      if (typeItem === "buy") {
        setActiveTable(2);
      } else if (typeItem === "sell") {
        setActiveTable(1);
      }
    }
    fetchCommodities();
  }, [location]);
  function mynormalNum(num) {
    num = num.replace(/,\s?/g, "");
    return num;
  }

  const handleCalcAmount = () => {
    let gramSoat = 0;
    if (active === "buy") {
      if (!isNaN(gramBuy)) {
        gramSoat = Number(gramBuy);
      }
      if (!isNaN(soatBuy)) {
        gramSoat = gramSoat + Number(soatBuy) / 1000;
      }
    } else {
      if (!isNaN(gramSell)) {
        gramSoat = Number(gramSell);
      }
      if (!isNaN(soatBuy)) {
        gramSoat = gramSoat + Number(soatSell) / 1000;
      }
    }
    if (!isNaN(gramSoat) && gramSoat > 0) {
      submitTradeRequest(
        null,
        active === "buy" ? gramSoat : -1 * gramSoat,
        selectedCommodity.id,
        null
      ).then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (active === "buy") {
            setAmountBuy(separateNum(Math.abs(res.data.data.cash_amount)));
          } else {
            setAmountSell(separateNum(Math.abs(res.data.data.cash_amount)));
          }
        }
      });
    }
  };
  useEffect(() => {
    handleCalcAmount();
  }, [soatSell, gramSell, soatBuy, gramBuy]);
  function handleSellPriceChange(e) {
    let num = persianToEnglishDigits(e.target.value);
    const rawValue = num.replace(/,/g, ""); // remove commas
    if (!isNaN(rawValue)) {
      setPriceSellOffer(rawValue);
    }
  }
  function persianToEnglishDigits(input) {
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    return input.replace(/[۰-۹]/g, (char) => persianDigits.indexOf(char));
  }
  function handleBuyPriceChange(e) {
    let num = persianToEnglishDigits(e.target.value);
    const rawValue = num.replace(/,/g, ""); // remove commas
    if (!isNaN(rawValue)) {
      setPriceBuyOffer(rawValue);
    }
  }
  useEffect(() => {
    setGramBuy(0);
    setGramSell(0);
    setSoatBuy(0);
    setSoatSell(0);
    setAmountBuy("");
    setAmountSell("");
    setPriceBuyOffer("");
    setPriceSellOffer("");
  }, [active, selectedCommodity.id]);
  function filterItems() {
    setActivate(false);
    setActiveOrder(activeOrderTmp);
  }
  const applyFilter = (type, amount, range) => {
    setFilterType(type);
    setFilterAmount(amount);
    setFilterRange(range);
    setActivateModal(false);
  };
  const actionButton = () => {
    return (
      <button className="action-bottom-sheet-button" onClick={filterItems}>
        اعمال فیلتر
      </button>
    );
  };

  function Openchanger(result) {
    setActivate(result);
  }
  const fetchPrices = (list) => {
    if (!isNaN(selectedCommodity.id) && Number(`${selectedCommodity.id}`) > 0)
      getCurrentGoldPrice(selectedCommodity.id).then((res) => {
        if (res.status == 200) {
          let data = res?.data?.data;
          if (data) {
            if (list) {
              let gram = 0;
              let soat = 0;
              if (!Array.isArray(list) && typeof list === "object") {
                gram =
                  String(list["offered_quantity"]).indexOf(".") != -1
                    ? Number(String(list["offered_quantity"]).split(".")[0]) > 0
                      ? Number(String(list["offered_quantity"]).split(".")[0])
                      : 0
                    : list["offered_quantity"];
                soat = parseInt((list["offered_quantity"] % 1) * 1000);
                if (active === "sell") {
                  setGramSell(gram);
                  setSoatSell(soat);
                  setPriceSellOffer(list["offered_price"]);
                  let res =
                    Number(Number(gram) * data.sell_price.gram) +
                    soat * Number(data.sell_price.soot);
                  document.getElementById("price_amount_sell").value =
                    new Intl.NumberFormat("en", {
                      maximumFractionDigits: 0,
                    }).format(res);
                }
                if (active == "buy") {
                  setGramBuy(gram);
                  setSoatBuy(soat);
                  setPriceBuyOffer(list["offered_price"]);

                  let res =
                    Number(Number(gram) * data.buy_price.gram) +
                    Number(soat) * Number(data.buy_price.soot);
                  setTimeout(() => {
                    if (!isNaN(res)) {
                      if (document.getElementById("price_amount_buy")) {
                        document.getElementById("price_amount_buy").value =
                          new Intl.NumberFormat("en", {
                            maximumFractionDigits: 0,
                          }).format(res);
                      }
                    }
                  }, 0);
                }
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
            }
          }
        }
      });
  };
  const handleSetOrderList = (list) => {
    fetchPrices(list);
  };
  useEffect(() => {
    const comName = commodities.find(
      (el) => el.id == selectedCommodity.id
    )?.name;
    setCommodityName(comName);
    if (selectedCommodity.id && !isNaN(`${selectedCommodity.id}`)) {
      fetchPrices();
    }
  }, [selectedCommodity.id, active]);
  useEffect(() => {
    async function fetchData() {
      getSystemContents().then((res) => {
        if (res.status == 200) {
          let data = res?.data?.results;

          if (data) {
            setLanding(data);
          }
        }
      });
    }
    fetchData();
  }, []);

  function separateNum(num) {
    // Round the number to the nearest integer
    const rounded = Math.round(num);

    // Convert to string with comma separators
    const withCommas = rounded.toLocaleString("en-US");

    // Map of English to Persian digits
    const persianDigits = {
      0: "۰",
      1: "۱",
      2: "۲",
      3: "۳",
      4: "۴",
      5: "۵",
      6: "۶",
      7: "۷",
      8: "۸",
      9: "۹",
      ",": ",", // Keep the comma
    };

    // Replace each character with Persian equivalent
    return withCommas.replace(/[0-9,]/g, (char) => persianDigits[char]);
  }

  function handleSubmit() {
    setIsLoading(true);
    submitOfferRequest(
      active === "buy" ? 0 : 1,
      active === "buy"
        ? Number(gramBuy) + Number(soatBuy / 1000)
        : Number(gramSell) + Number(soatSell / 1000),
      active === "buy" ? priceBuyOffer : priceSellOffer,
      selectedCommodity.id
    )
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200 || res.status == 201) {
          if (res.data) {
            toast.success("سفارش شما با موفقیت ثبت شد");
          }
        } else {
          toast.error(res.data?.errors[0]?.detail);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  }

  return (
    <>
      <>
        <MangeDashboard>
          <>
            <AfterLoginNav
              title={"بازار معاملات"}
              hasBack={() => navigate(-1)}
            />
            <div className="container margin-for-offer-container">
              <div className="row justify-content-center align-items-center">
                <div className="col-xl-6 col-md-8">
                  <div className="top-message-trade-wrapper">
                    <div className="top-message-trade">
                      {landing.map((item) => {
                        return item.key === "buy_gold_content" ? (
                          <>{item.value}</>
                        ) : null;
                      })}
                    </div>
                  </div>
                  <div className="select-commodity-limit-order">
                    <select
                      className="form-input-gray-custom gray-text-with-padding inline-select"
                      value={selectedCommodity.id}
                      onChange={(e) => {
                        const selected = commodities.find(
                          (el) => el.id == e.target.value
                        );
                        setSelectedCommodity(selected);
                      }}
                    >
                      {commodities.map((commodity) => (
                        <option value={commodity.id}>{commodity.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="trade-tabs-container">
                    <div className="trade-tab-wrapper">
                      <div className="trade-tab">
                        <div
                          className={
                            active == "buy"
                              ? "tab-item tab-item-active w-100"
                              : "tab-item w-100"
                          }
                          onClick={() => setActive("buy")}
                        >
                          خرید
                        </div>
                        <div
                          className={
                            active == "sell"
                              ? "tab-item tab-item-active w-100"
                              : "tab-item w-100"
                          }
                          onClick={() => setActive("sell")}
                        >
                          فروش
                        </div>
                      </div>
                    </div>
                  </div>
                  {active === "buy" ? (
                    <div className="form-container-offer-list">
                      <div className="authincation section-padding">
                        <div>
                          <div className="row">
                            <div>
                              <div className="w-100 pt-2 pb-2 pos-rel">
                                <span className="label-item-bazaar">
                                  قیمت پیشنهادی
                                </span>
                                <input
                                  name="price_offer_buy"
                                  id={"price_offer_buy"}
                                  className="form-input-gray-custom gray-text-with-padding"
                                  value={
                                    priceBuyOffer
                                      ? separateNum(Number(priceBuyOffer))
                                      : ""
                                  }
                                  onChange={handleBuyPriceChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div>
                              <div className="w-100 pt-2 pb-2 pos-rel">
                                <span className="label-item-bazaar">
                                  مبلغ روز {commodityName}
                                </span>
                                <input
                                  name="price_amount_buy"
                                  id={"price_amount_buy"}
                                  className="form-input-gray-custom gray-text-with-padding"
                                  onKeyUp={separateNum}
                                  value={amountBuy}
                                  readOnly={true}
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div
                              className={
                                selectedCommodity.ui_data.unit_name == null
                                  ? "col-2-items"
                                  : ""
                              }
                            >
                              <div className="w-100 pt-2 pb-2 pos-rel">
                                <input
                                  type="number"
                                  name="gram_buy"
                                  id={"gram_buy"}
                                  className="form-input-gray-custom"
                                  value={gramBuy != 0 ? gramBuy : ""}
                                  onChange={(e) => setGramBuy(e.target.value)}
                                />
                                <div className="bottom-row-label-item">
                                  {!selectedCommodity ||
                                  !selectedCommodity?.ui_data ||
                                  !selectedCommodity?.ui_data?.unit_name
                                    ? "گرم"
                                    : selectedCommodity &&
                                      selectedCommodity.ui_data &&
                                      selectedCommodity?.ui_data?.unit_name}
                                </div>
                              </div>
                              {selectedCommodity.ui_data?.unit_name == null ? (
                                <div className="w-100 pt-2 pb-2 pos-rel">
                                  <input
                                    type="number"
                                    name="soat_buy"
                                    id={"soat_buy"}
                                    maxLength={3}
                                    className="form-input-gray-custom"
                                    value={soatBuy != 0 ? soatBuy : ""}
                                    onChange={(e) => {
                                      if (!isNaN(e.target.value)) {
                                        setSoatBuy(e.target.value.slice(0, 3));
                                      } else {
                                        setSoatBuy("0");
                                      }
                                    }}
                                  />
                                  <div className="bottom-row-label-item">
                                    سوت
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                          <div className="w-100 pt-2 pb-4">
                            <button
                              name="buy"
                              className="form-input-button-custom"
                              type="button"
                              onClick={handleSubmit}
                            >
                              {isLoading ? (
                                <img
                                  src={"./loading.svg"}
                                  alt={""}
                                  className={"w-loading"}
                                />
                              ) : (
                                <>درخواست خرید</>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="form-container-offer-list">
                      <div className="authincation section-padding">
                        <div>
                          <div className="w-100 pt-2 pb-2 pos-rel">
                            <span className="label-item-bazaar">
                              قیمت پیشنهادی
                            </span>
                            <input
                              name="price_offer_sell"
                              id={"price_offer_sell"}
                              className="form-input-gray-custom gray-text-with-padding"
                              value={
                                priceSellOffer
                                  ? separateNum(Number(priceSellOffer))
                                  : ""
                              }
                              onChange={handleSellPriceChange}
                            />
                          </div>

                          <div className="row">
                            <div className="col-12">
                              <div className="w-100 pt-2 pb-2 pos-rel">
                                <span className="label-item-bazaar">
                                  مبلغ روز {commodityName}
                                </span>
                                <input
                                  name="price_amount_sell"
                                  id={"price_amount_sell"}
                                  className="form-input-gray-custom gray-text-with-padding"
                                  onKeyUp={separateNum}
                                  value={amountSell}
                                  readOnly={true}
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div
                              className={
                                selectedCommodity.ui_data.unit_name == null
                                  ? "col-2-items"
                                  : ""
                              }
                            >
                              <div className="w-100 pt-2 pb-2 pos-rel">
                                <input
                                  type="number"
                                  name="gram_sell"
                                  id={"gram_sell"}
                                  className="form-input-gray-custom"
                                  value={gramSell !== 0 ? gramSell : ""}
                                  onChange={(e) => setGramSell(e.target.value)}
                                />
                                <div className="bottom-row-label-item">
                                  {(commodities || []).find(
                                    (el) => el.id == selectedCommodity.id
                                  )?.ui_data?.unit_name == null
                                    ? "گرم"
                                    : (commodities || []).find(
                                        (el) => el.id == selectedCommodity.id
                                      )?.ui_data?.unit_name}
                                </div>
                              </div>
                              {(commodities || []).find(
                                (el) => el.id == selectedCommodity.id
                              )?.ui_data?.unit_name == null ? (
                                <div className="w-100 pt-2 pb-2 pos-rel">
                                  <input
                                    type="number"
                                    name="soat_sell"
                                    id={"soat_sell"}
                                    className="form-input-gray-custom"
                                    value={soatSell !== 0 ? soatSell : ""}
                                    onChange={(e) => {
                                      if (!isNaN(e.target.value)) {
                                        setSoatSell(e.target.value.slice(0, 3));
                                      } else {
                                        setSoatSell("0");
                                      }
                                    }}
                                  />
                                  <div className="bottom-row-label-item">
                                    سوت
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                          <div className="w-100 pt-2 pb-4">
                            {active == "buy" ? (
                              <button
                                name="sell"
                                className="form-input-button-custom"
                                type="button"
                                onClick={handleSubmit}
                              >
                                {false ? (
                                  <img
                                    src={"./loading.svg"}
                                    alt={""}
                                    className={"w-loading"}
                                  />
                                ) : (
                                  <>درخواست فروش</>
                                )}
                              </button>
                            ) : (
                              <button
                                className="form-input-button-custom"
                                type="button"
                                onClick={handleSubmit}
                              >
                                {isLoading ? (
                                  <img
                                    src={"./loading.svg"}
                                    alt={""}
                                    className={"w-loading"}
                                  />
                                ) : (
                                  <>درخواست فروش</>
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-xl-10 col-md-8">
                  <div className="filter-container-items-desktop">
                    <div className="filter-cat-row">
                      <div onClick={() => setActivateModal(true)}>
                        <img src={"/images/svg/filters.svg"} alt={""} />
                        فیلترها
                      </div>
                      {filterAmount ||
                      (Array.isArray(filterRange) && filterRange.length > 0) ||
                      filterType === 0 ||
                      filterType === 1 ? (
                        <div
                          className="remove-filters"
                          onClick={() => {
                            setFilterRange([]);
                            setFilterAmount(null);
                            setFilterType(null);
                          }}
                        >
                          &#10060;
                        </div>
                      ) : (
                        <></>
                      )}
                      <div onClick={() => setActivate(!activate)}>
                        <img src={"/images/svg/category.svg"} alt={""} />
                        دسته بندی ها
                      </div>
                      {!isNaN(activeOrder) && activeOrder !== null && (
                        <div
                          className="remove-filters"
                          onClick={() => {
                            setActiveOrder(null);
                          }}
                        >
                          &#10060;
                        </div>
                      )}
                    </div>
                    {isTabletOrMobile ? (
                      <BottomSheet
                        activate={activate}
                        actionButtons={actionButton}
                        onClose={() => setActivate(false)}
                      >
                        <>
                          <div className="select-box-row-sheet">
                            <input
                              id={"low-price-low-cap"}
                              type={"radio"}
                              onChange={() => (activeOrderTmp = 1)}
                              name="category-sheet-filter"
                            />
                            <label htmlFor="low-price-low-cap">
                              ارزان‌ترین قیمت در حجم کم
                            </label>
                          </div>
                          <div className="select-box-row-sheet">
                            <input
                              id={"low-price-high-cap"}
                              type={"radio"}
                              onChange={() => (activeOrderTmp = 2)}
                              name="category-sheet-filter"
                            />
                            <label htmlFor={"low-price-high-cap"}>
                              ارزان‌ترین قیمت در حجم زیاد
                            </label>
                          </div>
                          <div className="select-box-row-sheet">
                            <input
                              id={"high-price-low-cap"}
                              type={"radio"}
                              onChange={() => (activeOrderTmp = 3)}
                              name="category-sheet-filter"
                            />
                            <label htmlFor={"high-price-low-cap"}>
                              گرانترین قیمت در حجم کم
                            </label>
                          </div>
                          <div className="select-box-row-sheet">
                            <input
                              id={"high-price-high-cap"}
                              type={"radio"}
                              onChange={() => (activeOrderTmp = 4)}
                              name="category-sheet-filter"
                            />
                            <label htmlFor={"high-price-high-cap"}>
                              گرانترین قیمت در حجم زیاد
                            </label>
                          </div>
                        </>
                      </BottomSheet>
                    ) : (
                      <CategoryModal
                        setActiveOrder={(order) => setActiveOrder(order)}
                        modalIsOpen={activate}
                        Openchanger={Openchanger}
                      />
                    )}
                    {activateModal && (
                      <FilterModal
                        closeModal={() => setActivateModal(false)}
                        applyFilter={applyFilter}
                      />
                    )}
                    <div className="offer-list-desktop-wrapper">
                      <div className="filters-items-home">
                        {!isTabletOrMobile && (
                          <>
                            <button
                              className={
                                activeTable === 1
                                  ? "form-input-button-custom"
                                  : "form-input-button-custom not-active-login"
                              }
                              onClick={() => {
                                setActive("sell");
                                setActiveTable(1);
                              }}
                            >
                              پیشنهادهای خرید کاربران
                            </button>
                            <button
                              className={
                                activeTable === 2
                                  ? "form-input-button-custom"
                                  : "form-input-button-custom not-active-login"
                              }
                              onClick={() => {
                                setActive("buy");
                                setActiveTable(2);
                              }}
                            >
                              پیشنهادهای فروش کاربران
                            </button>
                          </>
                        )}
                        {!isTabletOrMobile ? (
                          <div className="offer-list-on-home">
                            <OfferList
                              activeTable={activeTable}
                              activeOffer={(active) => setActive(active)}
                              orderList={handleSetOrderList}
                              activeOrder={activeOrder}
                              filterType={filterType}
                              filterAmount={filterAmount}
                              selectedCommodity={selectedCommodity}
                              filterRange={filterRange}
                              initAmount={initAmount}
                              setActiveTable={(active) =>
                                setActiveTable(active)
                              }
                            />
                          </div>
                        ) : (
                          <div className="offer-list-on-home">
                            <OfferList
                              activeOffer={(active) => setActive(active)}
                              orderList={handleSetOrderList}
                              activeOrder={activeOrder}
                              filterType={filterType}
                              filterAmount={filterAmount}
                              selectedCommodity={selectedCommodity}
                              filterRange={filterRange}
                              initAmount={initAmount}
                              setActiveTable={(active) =>
                                setActiveTable(active)
                              }
                            />
                          </div>
                        )}
                        <div className="margin-for-offer-lists lower-margin-for-offer-lists">
                          <div className="scroll">
                            <div>
                              {isTabletOrMobile ? (
                                <ScrollOnMainPage />
                              ) : (
                                commodities.map(
                                  (el) =>
                                    el.id == selectedCommodity.id && (
                                      <ScrollOnMainPage commodity={el} />
                                    )
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </MangeDashboard>
      </>
    </>
  );
}
